module.exports = __webpack_public_path__ + "img/times.ce2b5546.svg";